export default __webpack_public_path__ + "static/media/1.ea484dd0.jpg";